 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import VULCANTESTPILOT_FRONTCOVER from '@/components/VulcanTestPilot_frontcover'
 import VULCANTESTPILOT_DEDICATION1 from '@/components/VulcanTestPilot_dedication1'
 import VULCANTESTPILOT_TITLE from '@/components/VulcanTestPilot_title'
 import VULCANTESTPILOT_COPYRIGHT from '@/components/VulcanTestPilot_copyright'
 import VULCANTESTPILOT_TOC from '@/components/VulcanTestPilot_toc'
 import VULCANTESTPILOT_DEDICATION2 from '@/components/VulcanTestPilot_dedication2'
 import VULCANTESTPILOT_ACKNOWLEDGMENTS from '@/components/VulcanTestPilot_acknowledgments'
 import VULCANTESTPILOT_FOREWORD from '@/components/VulcanTestPilot_foreword'
 import VULCANTESTPILOT_APPRECIATION from '@/components/VulcanTestPilot_appreciation'
 import VULCANTESTPILOT_INTRODUCTION from '@/components/VulcanTestPilot_introduction'
 import VULCANTESTPILOT_PROLOGUE from '@/components/VulcanTestPilot_prologue'
 import VULCANTESTPILOT_PROLOGUE1 from '@/components/VulcanTestPilot_prologue1'
 import VULCANTESTPILOT_PROLOGUE2 from '@/components/VulcanTestPilot_prologue2'
 import VULCANTESTPILOT_PROLOGUE3 from '@/components/VulcanTestPilot_prologue3'
 import VULCANTESTPILOT_CHAPTER1 from '@/components/VulcanTestPilot_chapter1'
 import VULCANTESTPILOT_CHAPTER11 from '@/components/VulcanTestPilot_chapter1-1'
 import VULCANTESTPILOT_CHAPTER12 from '@/components/VulcanTestPilot_chapter1-2'
 import VULCANTESTPILOT_CHAPTER2 from '@/components/VulcanTestPilot_chapter2'
 import VULCANTESTPILOT_CHAPTER21 from '@/components/VulcanTestPilot_chapter2-1'
 import VULCANTESTPILOT_CHAPTER22 from '@/components/VulcanTestPilot_chapter2-2'
 import VULCANTESTPILOT_CHAPTER23 from '@/components/VulcanTestPilot_chapter2-3'
 import VULCANTESTPILOT_CHAPTER24 from '@/components/VulcanTestPilot_chapter2-4'
 import VULCANTESTPILOT_CHAPTER25 from '@/components/VulcanTestPilot_chapter2-5'
 import VULCANTESTPILOT_CHAPTER3 from '@/components/VulcanTestPilot_chapter3'
 import VULCANTESTPILOT_CHAPTER31 from '@/components/VulcanTestPilot_chapter3-1'
 import VULCANTESTPILOT_CHAPTER32 from '@/components/VulcanTestPilot_chapter3-2'
 import VULCANTESTPILOT_CHAPTER33 from '@/components/VulcanTestPilot_chapter3-3'
 import VULCANTESTPILOT_CHAPTER34 from '@/components/VulcanTestPilot_chapter3-4'
 import VULCANTESTPILOT_CHAPTER35 from '@/components/VulcanTestPilot_chapter3-5'
 import VULCANTESTPILOT_CHAPTER36 from '@/components/VulcanTestPilot_chapter3-6'
 import VULCANTESTPILOT_CHAPTER37 from '@/components/VulcanTestPilot_chapter3-7'
 import VULCANTESTPILOT_CHAPTER4 from '@/components/VulcanTestPilot_chapter4'
 import VULCANTESTPILOT_CHAPTER41 from '@/components/VulcanTestPilot_chapter4-1'
 import VULCANTESTPILOT_CHAPTER42 from '@/components/VulcanTestPilot_chapter4-2'
 import VULCANTESTPILOT_CHAPTER43 from '@/components/VulcanTestPilot_chapter4-3'
 import VULCANTESTPILOT_CHAPTER44 from '@/components/VulcanTestPilot_chapter4-4'
 import VULCANTESTPILOT_CHAPTER45 from '@/components/VulcanTestPilot_chapter4-5'
 import VULCANTESTPILOT_CHAPTER46 from '@/components/VulcanTestPilot_chapter4-6'
 import VULCANTESTPILOT_CHAPTER47 from '@/components/VulcanTestPilot_chapter4-7'
 import VULCANTESTPILOT_CHAPTER48 from '@/components/VulcanTestPilot_chapter4-8'
 import VULCANTESTPILOT_CHAPTER5 from '@/components/VulcanTestPilot_chapter5'
 import VULCANTESTPILOT_CHAPTER51 from '@/components/VulcanTestPilot_chapter5-1'
 import VULCANTESTPILOT_CHAPTER52 from '@/components/VulcanTestPilot_chapter5-2'
 import VULCANTESTPILOT_CHAPTER53 from '@/components/VulcanTestPilot_chapter5-3'
 import VULCANTESTPILOT_CHAPTER54 from '@/components/VulcanTestPilot_chapter5-4'
 import VULCANTESTPILOT_CHAPTER55 from '@/components/VulcanTestPilot_chapter5-5'
 import VULCANTESTPILOT_CHAPTER56 from '@/components/VulcanTestPilot_chapter5-6'
 import VULCANTESTPILOT_CHAPTER57 from '@/components/VulcanTestPilot_chapter5-7'
 import VULCANTESTPILOT_CHAPTER58 from '@/components/VulcanTestPilot_chapter5-8'
 import VULCANTESTPILOT_CHAPTER59 from '@/components/VulcanTestPilot_chapter5-9'
 import VULCANTESTPILOT_CHAPTER510 from '@/components/VulcanTestPilot_chapter5-10'
 import VULCANTESTPILOT_CHAPTER511 from '@/components/VulcanTestPilot_chapter5-11'
 import VULCANTESTPILOT_CHAPTER512 from '@/components/VulcanTestPilot_chapter5-12'
 import VULCANTESTPILOT_CHAPTER513 from '@/components/VulcanTestPilot_chapter5-13'
 import VULCANTESTPILOT_CHAPTER514 from '@/components/VulcanTestPilot_chapter5-14'
 import VULCANTESTPILOT_CHAPTER515 from '@/components/VulcanTestPilot_chapter5-15'
 import VULCANTESTPILOT_CHAPTER516 from '@/components/VulcanTestPilot_chapter5-16'
 import VULCANTESTPILOT_CHAPTER517 from '@/components/VulcanTestPilot_chapter5-17'
 import VULCANTESTPILOT_CHAPTER518 from '@/components/VulcanTestPilot_chapter5-18'
 import VULCANTESTPILOT_CHAPTER519 from '@/components/VulcanTestPilot_chapter5-19'
 import VULCANTESTPILOT_CHAPTER520 from '@/components/VulcanTestPilot_chapter5-20'
 import VULCANTESTPILOT_CHAPTER521 from '@/components/VulcanTestPilot_chapter5-21'
 import VULCANTESTPILOT_CHAPTER522 from '@/components/VulcanTestPilot_chapter5-22'
 import VULCANTESTPILOT_CHAPTER523 from '@/components/VulcanTestPilot_chapter5-23'
 import VULCANTESTPILOT_CHAPTER524 from '@/components/VulcanTestPilot_chapter5-24'
 import VULCANTESTPILOT_CHAPTER525 from '@/components/VulcanTestPilot_chapter5-25'
 import VULCANTESTPILOT_CHAPTER526 from '@/components/VulcanTestPilot_chapter5-26'
 import VULCANTESTPILOT_CHAPTER527 from '@/components/VulcanTestPilot_chapter5-27'
 import VULCANTESTPILOT_CHAPTER528 from '@/components/VulcanTestPilot_chapter5-28'
 import VULCANTESTPILOT_CHAPTER529 from '@/components/VulcanTestPilot_chapter5-29'
 import VULCANTESTPILOT_CHAPTER530 from '@/components/VulcanTestPilot_chapter5-30'
 import VULCANTESTPILOT_CHAPTER531 from '@/components/VulcanTestPilot_chapter5-31'
 import VULCANTESTPILOT_CHAPTER532 from '@/components/VulcanTestPilot_chapter5-32'
 import VULCANTESTPILOT_CHAPTER533 from '@/components/VulcanTestPilot_chapter5-33'
 import VULCANTESTPILOT_CHAPTER6 from '@/components/VulcanTestPilot_chapter6'
 import VULCANTESTPILOT_CHAPTER61 from '@/components/VulcanTestPilot_chapter6-1'
 import VULCANTESTPILOT_CHAPTER62 from '@/components/VulcanTestPilot_chapter6-2'
 import VULCANTESTPILOT_CHAPTER63 from '@/components/VulcanTestPilot_chapter6-3'
 import VULCANTESTPILOT_CHAPTER64 from '@/components/VulcanTestPilot_chapter6-4'
 import VULCANTESTPILOT_CHAPTER65 from '@/components/VulcanTestPilot_chapter6-5'
 import VULCANTESTPILOT_CHAPTER66 from '@/components/VulcanTestPilot_chapter6-6'
 import VULCANTESTPILOT_CHAPTER67 from '@/components/VulcanTestPilot_chapter6-7'
 import VULCANTESTPILOT_CHAPTER7 from '@/components/VulcanTestPilot_chapter7'
 import VULCANTESTPILOT_CHAPTER71 from '@/components/VulcanTestPilot_chapter7-1'
 import VULCANTESTPILOT_CHAPTER72 from '@/components/VulcanTestPilot_chapter7-2'
 import VULCANTESTPILOT_CHAPTER73 from '@/components/VulcanTestPilot_chapter7-3'
 import VULCANTESTPILOT_CHAPTER74 from '@/components/VulcanTestPilot_chapter7-4'
 import VULCANTESTPILOT_CHAPTER75 from '@/components/VulcanTestPilot_chapter7-5'
 import VULCANTESTPILOT_CHAPTER76 from '@/components/VulcanTestPilot_chapter7-6'
 import VULCANTESTPILOT_CHAPTER77 from '@/components/VulcanTestPilot_chapter7-7'
 import VULCANTESTPILOT_CHAPTER78 from '@/components/VulcanTestPilot_chapter7-8'
 import VULCANTESTPILOT_CHAPTER79 from '@/components/VulcanTestPilot_chapter7-9'
 import VULCANTESTPILOT_CHAPTER710 from '@/components/VulcanTestPilot_chapter7-10'
 import VULCANTESTPILOT_CHAPTER711 from '@/components/VulcanTestPilot_chapter7-11'
 import VULCANTESTPILOT_CHAPTER712 from '@/components/VulcanTestPilot_chapter7-12'
 import VULCANTESTPILOT_CHAPTER713 from '@/components/VulcanTestPilot_chapter7-13'
 import VULCANTESTPILOT_CHAPTER714 from '@/components/VulcanTestPilot_chapter7-14'
 import VULCANTESTPILOT_CHAPTER715 from '@/components/VulcanTestPilot_chapter7-15'
 import VULCANTESTPILOT_CHAPTER716 from '@/components/VulcanTestPilot_chapter7-16'
 import VULCANTESTPILOT_CHAPTER717 from '@/components/VulcanTestPilot_chapter7-17'
 import VULCANTESTPILOT_CHAPTER718 from '@/components/VulcanTestPilot_chapter7-18'
 import VULCANTESTPILOT_CHAPTER719 from '@/components/VulcanTestPilot_chapter7-19'
 import VULCANTESTPILOT_CHAPTER720 from '@/components/VulcanTestPilot_chapter7-20'
 import VULCANTESTPILOT_CHAPTER721 from '@/components/VulcanTestPilot_chapter7-21'
 import VULCANTESTPILOT_CHAPTER722 from '@/components/VulcanTestPilot_chapter7-22'
 import VULCANTESTPILOT_CHAPTER723 from '@/components/VulcanTestPilot_chapter7-23'
 import VULCANTESTPILOT_CHAPTER724 from '@/components/VulcanTestPilot_chapter7-24'
 import VULCANTESTPILOT_CHAPTER725 from '@/components/VulcanTestPilot_chapter7-25'
 import VULCANTESTPILOT_CHAPTER726 from '@/components/VulcanTestPilot_chapter7-26'
 import VULCANTESTPILOT_CHAPTER727 from '@/components/VulcanTestPilot_chapter7-27'
 import VULCANTESTPILOT_CHAPTER728 from '@/components/VulcanTestPilot_chapter7-28'
 import VULCANTESTPILOT_CHAPTER729 from '@/components/VulcanTestPilot_chapter7-29'
 import VULCANTESTPILOT_CHAPTER730 from '@/components/VulcanTestPilot_chapter7-30'
 import VULCANTESTPILOT_CHAPTER731 from '@/components/VulcanTestPilot_chapter7-31'
 import VULCANTESTPILOT_CHAPTER732 from '@/components/VulcanTestPilot_chapter7-32'
 import VULCANTESTPILOT_CHAPTER733 from '@/components/VulcanTestPilot_chapter7-33'
 import VULCANTESTPILOT_CHAPTER734 from '@/components/VulcanTestPilot_chapter7-34'
 import VULCANTESTPILOT_CHAPTER8 from '@/components/VulcanTestPilot_chapter8'
 import VULCANTESTPILOT_CHAPTER81 from '@/components/VulcanTestPilot_chapter8-1'
 import VULCANTESTPILOT_CHAPTER82 from '@/components/VulcanTestPilot_chapter8-2'
 import VULCANTESTPILOT_CHAPTER83 from '@/components/VulcanTestPilot_chapter8-3'
 import VULCANTESTPILOT_CHAPTER84 from '@/components/VulcanTestPilot_chapter8-4'
 import VULCANTESTPILOT_CHAPTER85 from '@/components/VulcanTestPilot_chapter8-5'
 import VULCANTESTPILOT_CHAPTER86 from '@/components/VulcanTestPilot_chapter8-6'
 import VULCANTESTPILOT_CHAPTER87 from '@/components/VulcanTestPilot_chapter8-7'
 import VULCANTESTPILOT_CHAPTER88 from '@/components/VulcanTestPilot_chapter8-8'
 import VULCANTESTPILOT_CHAPTER9 from '@/components/VulcanTestPilot_chapter9'
 import VULCANTESTPILOT_CHAPTER91 from '@/components/VulcanTestPilot_chapter9-1'
 import VULCANTESTPILOT_CHAPTER92 from '@/components/VulcanTestPilot_chapter9-2'
 import VULCANTESTPILOT_CHAPTER93 from '@/components/VulcanTestPilot_chapter9-3'
 import VULCANTESTPILOT_CHAPTER94 from '@/components/VulcanTestPilot_chapter9-4'
 import VULCANTESTPILOT_GLOSSARY from '@/components/VulcanTestPilot_glossary'
 import VULCANTESTPILOT_TIMECHART from '@/components/VulcanTestPilot_timechart'
 import VULCANTESTPILOT_APPENDIX1 from '@/components/VulcanTestPilot_appendix1'
 import VULCANTESTPILOT_APPENDIX11 from '@/components/VulcanTestPilot_appendix1-1'
 import VULCANTESTPILOT_APPENDIX12 from '@/components/VulcanTestPilot_appendix1-2'
 import VULCANTESTPILOT_APPENDIX13 from '@/components/VulcanTestPilot_appendix1-3'
 import VULCANTESTPILOT_APPENDIX2 from '@/components/VulcanTestPilot_appendix2'
 import VULCANTESTPILOT_APPENDIX21 from '@/components/VulcanTestPilot_appendix2-1'
 import VULCANTESTPILOT_APPENDIX22 from '@/components/VulcanTestPilot_appendix2-2'
 import VULCANTESTPILOT_APPENDIX23 from '@/components/VulcanTestPilot_appendix2-3'
 import VULCANTESTPILOT_APPENDIX3 from '@/components/VulcanTestPilot_appendix3'
 import VULCANTESTPILOT_APPENDIX31 from '@/components/VulcanTestPilot_appendix3-1'
 import VULCANTESTPILOT_APPENDIX32 from '@/components/VulcanTestPilot_appendix3-2'
 import VULCANTESTPILOT_APPENDIX33 from '@/components/VulcanTestPilot_appendix3-3'
 import VULCANTESTPILOT_APPENDIX4 from '@/components/VulcanTestPilot_appendix4'
 import VULCANTESTPILOT_APPENDIX41 from '@/components/VulcanTestPilot_appendix4-1'
 import VULCANTESTPILOT_APPENDIX42 from '@/components/VulcanTestPilot_appendix4-2'
 import VULCANTESTPILOT_APPENDIX5 from '@/components/VulcanTestPilot_appendix5'
 import VULCANTESTPILOT_APPENDIX6 from '@/components/VulcanTestPilot_appendix6'
 import VULCANTESTPILOT_APPENDIX7 from '@/components/VulcanTestPilot_appendix7'
 import VULCANTESTPILOT_FOOTNOTE from '@/components/VulcanTestPilot_footnote'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/VulcanTestPilot_frontcover",
 			"name" : "VulcanTestPilot_frontcover",
 			"component" : VULCANTESTPILOT_FRONTCOVER
 		},
 		{
 			"path" : "/VulcanTestPilot_dedication1",
 			"name" : "VulcanTestPilot_dedication1",
 			"component" : VULCANTESTPILOT_DEDICATION1
 		},
 		{
 			"path" : "/VulcanTestPilot_title",
 			"name" : "VulcanTestPilot_title",
 			"component" : VULCANTESTPILOT_TITLE
 		},
 		{
 			"path" : "/VulcanTestPilot_copyright",
 			"name" : "VulcanTestPilot_copyright",
 			"component" : VULCANTESTPILOT_COPYRIGHT
 		},
 		{
 			"path" : "/VulcanTestPilot_toc",
 			"name" : "VulcanTestPilot_toc",
 			"component" : VULCANTESTPILOT_TOC
 		},
 		{
 			"path" : "/VulcanTestPilot_dedication2",
 			"name" : "VulcanTestPilot_dedication2",
 			"component" : VULCANTESTPILOT_DEDICATION2
 		},
 		{
 			"path" : "/VulcanTestPilot_acknowledgments",
 			"name" : "VulcanTestPilot_acknowledgments",
 			"component" : VULCANTESTPILOT_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/VulcanTestPilot_foreword",
 			"name" : "VulcanTestPilot_foreword",
 			"component" : VULCANTESTPILOT_FOREWORD
 		},
 		{
 			"path" : "/VulcanTestPilot_appreciation",
 			"name" : "VulcanTestPilot_appreciation",
 			"component" : VULCANTESTPILOT_APPRECIATION
 		},
 		{
 			"path" : "/VulcanTestPilot_introduction",
 			"name" : "VulcanTestPilot_introduction",
 			"component" : VULCANTESTPILOT_INTRODUCTION
 		},
 		{
 			"path" : "/VulcanTestPilot_prologue",
 			"name" : "VulcanTestPilot_prologue",
 			"component" : VULCANTESTPILOT_PROLOGUE
 		},
 		{
 			"path" : "/VulcanTestPilot_prologue1",
 			"name" : "VulcanTestPilot_prologue1",
 			"component" : VULCANTESTPILOT_PROLOGUE1
 		},
 		{
 			"path" : "/VulcanTestPilot_prologue2",
 			"name" : "VulcanTestPilot_prologue2",
 			"component" : VULCANTESTPILOT_PROLOGUE2
 		},
 		{
 			"path" : "/VulcanTestPilot_prologue3",
 			"name" : "VulcanTestPilot_prologue3",
 			"component" : VULCANTESTPILOT_PROLOGUE3
 		},
 		{
 			"path" : "/VulcanTestPilot_chapter1",
 			"name" : "VulcanTestPilot_chapter1",
 			"component" : VULCANTESTPILOT_CHAPTER1
 		},
 		{
 			"path" : "/VulcanTestPilot_chapter1-1",
 			"name" : "VulcanTestPilot_chapter1-1",
 			"component" : VULCANTESTPILOT_CHAPTER11
 		},
 		{
 			"path" : "/VulcanTestPilot_chapter1-2",
 			"name" : "VulcanTestPilot_chapter1-2",
 			"component" : VULCANTESTPILOT_CHAPTER12
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js